<template>
<div>
  <div v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-custom-class="prod-custom-loading" class="platform-category-input">
    {{inputText}} 
    <template>
      <el-button v-if="!hideEditBtn" type="link" @click="editCategoryClick">修改类目</el-button>
      <el-button v-if="isShowSyncBtn && sdDialog.data.length > 0" type="link" @click="sdDialog.visible = true">同步平台类目</el-button>
    </template>
    <!-- <el-button v-if="platform === 'fxg'" type="link" @click="switchGrayShopDialog">切换店铺</el-button> -->
    <Dialog :platform="platform" :shopId.sync="shopId" ref="dialog" :baseItemId.sync="baseItemId"/>
  </div>
  <PredictionCategory v-if="showPredictionAi" ref="PredictionCategoryRef" :inputText="inputText" :categoryIds.sync="categoryIds" :shopId.sync="shopId" :platform.sync="platform" :baseItemId.sync="baseItemId" @fxgRecommendId-change="handleFxgRecommendIdChange" @updateIds="emitChange"/>
  <!-- 同步进度 -->
  <sync-progress ref="syncProgress"></sync-progress>
  <!-- 选择店铺同步平台类目 -->
  <shop-dialog :visible.sync="sdDialog.visible" :data="sdDialog.data" @ok="syncCategoryClick"></shop-dialog>
  <shop-dialog :grayShop="true" :visible.sync="grayShopDialog.visible" :data="grayShopDialog.data" @ok="grayShopDialogOk"></shop-dialog>
</div>
</template>

<script>
import {mapGetters} from 'vuex';
import Dialog from './CascaderDialog'
import ReuseLastCategory from "./ReuseLastCategory.vue";
import PredictionCategory from "./predictionCategory.vue";
import {PLATFORMS} from '../../dictionary'
import { syncShopCategory } from '@/servers/base/shop';
import { listFxgShopsGrayStatus, setShopCache } from '@api/base/index.js';
import SyncProgress from '@/components/base/shop-manage/SyncProgress.vue';
import ShopDialog from './ShopDialog.vue';

// 平台类目input组件

// 示例
// <PlatformCategoryInput v-model="categoryIds" platform="kuaishou" />
// categoryIds -> 类目id数组
// platform -> 当前平台

export default {
  model: {
    prop: 'categoryIds',
    event: 'change'
  },
  inject: ['elFormItem'],
  props: {
    categoryIds: {
      type: Array,
      default() {
        return []
      }
    },
    platform: {
      default: '',
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        return PLATFORMS.indexOf(value) !== -1
      }
    },
    hideEditBtn: {
      type: Boolean,
      default: false
    },
    shopId: {
      type: String | Number,
      default: ''
    },
    baseItemId: {
      type: [Number, String],
      default: ''
    },
    isSupportAi: {
      type: Boolean,
      default: false
    },
    isShowSyncBtn:{
      type: Boolean,
      default: true
    },
  },
  components: {
    Dialog,
    ReuseLastCategory,
    SyncProgress,
    ShopDialog,
    PredictionCategory,
  },
  data() {
    return {
      categoryNames: [],
      names: [],
      lastLevelCateGory: {},
      loading: false,
      sdDialog: { visible: false, data: [] },
      grayShopDialog: { visible: false, data: [] },
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'shops_authorizedShops']),
    inputText() {
      if (this.names && this.names.length) { // 如果本地有缓存的类目，显示类目名称
        return this.names.join(' > ')
      }
      return this.categoryNames.length ? this.categoryNames.join(' > ') : this.categoryIds.join(' > ')
    },
    showPredictionAi() {
      return this.isSupportAi && (!this.categoryIds.length || this.platform === 'fxg')
    }
  },
  watch: {
    categoryIds: {
      handler(v, oldV) {
        if(!v.length){
          this.handleReset();
        } else if (!this.categoryNames.length) {
          // 只有在categoryIds真正变化时才处理
          if (JSON.stringify(v) !== JSON.stringify(oldV)) {
            this.$nextTick(() => {
              if (!this.categoryNames.length && !this.names.length) {
                this.getLabels()
              }
            })
          }
        }
      },
      immediate: true
    },
    shopId(v) {
      v && this.getLabels()
    },
    platform() {
      this.handleReset();
    },
    inputText(names) {
      this.$emit('nameChange', names ? names.split(' > ') : [], this.categoryIds)
    }
  },
  methods: {
    handleNameToChangeCate(payload){
      this.$refs.PredictionCategoryRef.handlePredictCate(payload)
    },
    // 父组件方法中
    handleFxgRecommendIdChange(data) {
        this.$emit('fxgRecommendId-update', data);
    },
    getLabels() {
      if(!this.categoryIds?.length) return
      this.loading = true
      this.$refs.dialog.method_getLabels(this.categoryIds, (names, lastLevelCateGory) => {
        this.lastLevelCateGory = lastLevelCateGory;
        this.categoryNames = names
        this.loading = false
        this.cacheIds(this.categoryIds, names);
        this.validCategoryNames(names);
      })
    },
    editCategoryClick() {
      this.$refs.dialog.method_open(this.categoryIds, this.updateCategoryIds)
    },
    handleReset() {
      this.categoryNames = []
      this.$refs.dialog && this.$refs.dialog.method_clear()
      this.names = [];
    },
    updateCategoryIds(res) {
      const [categoryIds, labels, lastLevelCateGory] = res
      this.categoryNames = labels
      this.lastLevelCateGory = lastLevelCateGory;
      this.cacheIds(categoryIds, labels);
      this.$emit('change', categoryIds, labels, lastLevelCateGory)
      this.elFormItem && this.elFormItem.elForm.validateField(this.elFormItem.prop);
      // 防止本地缓存名称一直覆盖新的所选名称
      this.names = []
    },
    method_getCategoryNames() {
      return [].concat(this.categoryNames)
    },
    method_getLastLevelCateGory() {
      return this.lastLevelCateGory
    },
    cacheIds(newIds, names) {
      if (!newIds.length || !names.length) return;
      const staffId = this.userInfo.staffId;
      let ids = localStorage.getItem(staffId);
      if (ids) {
        try {
          ids = JSON.parse(ids);
        } catch(e) {
          console.error(e);
        }
      } else {
        ids = {};
      }
      if (!ids[this.platform]) ids[this.platform] = {};
      ids[this.platform].ids = newIds;
      ids[this.platform].names = names
      ids[this.platform].lastLevelCategory = this.lastLevelCateGory
      localStorage.setItem(staffId, JSON.stringify(ids));
    },
    emitChange(category) {
      this.names = category.names;
      this.lastLevelCategory = category.lastLevelCategory
      this.$emit('change', category.ids, category.names, this.lastLevelCategory);
      this.elFormItem && this.elFormItem.elForm.validateField(this.elFormItem.prop);
    },
    validCategoryNames(names) {
      const hasNoMatchCategory = this.categoryIds.some(item => {
        return (names || []).some(name => {
          return name == item;
        });
      })
      if (hasNoMatchCategory || (this.categoryIds?.length && !this.categoryNames?.length)) {
        this.$message.warning('当前存在未匹配类目，请重新选择类目或同步平台类目');
        this.$refs.dialog && this.$refs.dialog.method_clear()
        this.emitChange({
          names: [],
          ids: [],
        });
      }
    },
    async syncCategoryClick(shopId) {
      const success = await syncShopCategory({shopId})
      if (success) {
        this.$refs.syncProgress.showDialog({shopId});
      }
    },
    async switchGrayShopDialog() {
      const res = await listFxgShopsGrayStatus()
      this.grayShopDialog.visible = true
      this.grayShopDialog.data = res.data || []
    },
    async grayShopDialogOk(shopId) {
      const res = await setShopCache({ shopId })
      if(res.result == 1) {
        this.$emit('setShopCache')
      }
    }
  },
  mounted() {
    this.sdDialog.data = this.shops_authorizedShops && this.shops_authorizedShops(this.platform) || [];
  },
  beforeDestroy() {
    // 清理数据引用，避免内存泄露
    this.categoryNames = null;
    this.names = null;
    this.lastLevelCateGory = null;
    this.sdDialog = null;
    
    // 清理子组件引用
    if (this.$refs.dialog) {
      this.$refs.dialog = null;
    }
    if (this.$refs.syncProgress) {
      this.$refs.syncProgress = null;
    }
  }
}
</script>

<style scoped lang="scss">
.platform-category-input {
  // 使用自定义 loading 类，避免 scoped 隔离影响
  ::v-deep .prod-custom-loading {
    background-color: rgba(255, 255, 255, 0.8) !important;
    .el-loading-spinner {
      top: 0;
      margin-top: 0;
      .el-icon-loading {
        color: #999;
      }
    }
  }
}
</style>